import { Observable } from 'rxjs';
import { TechnicalSpecificationsSectionsState } from '../entities/sections-state/technicalSpecificationsSectionsState';
import { PersonalDataSectionsState } from '../entities/sections-state/personalDataSectionsState';
import { DocumentsSectionsState } from '../entities/sections-state/documentsSectionsState';

export abstract class GridApplicationCommentsService {
  public abstract createTechnicalSpecificationsSectionComment(updateRequest: TechnicalSpecificationsSectionsState): Observable<any>;

  public abstract updateTechnicalSpecificationsSectionComment(updateRequest: TechnicalSpecificationsSectionsState): Observable<any>;

  public abstract createPersonalDataSectionComment(updateRequest: PersonalDataSectionsState): Observable<any>;

  public abstract updatePersonalDataSectionComment(updateRequest: PersonalDataSectionsState): Observable<any>;

  public abstract createDocumentsSectionComment(updateRequest: DocumentsSectionsState): Observable<any>;

  public abstract updateDocumentsSectionComment(updateRequest: DocumentsSectionsState): Observable<any>;
}
